import LineChartIcon from "../../icons/lineChartIcon";
import NetworkIcon from "../../icons/networkIcon";
import TruckIcon from "../../icons/truckIcon";
import VisionCard from "./visionCard";
import { useTranslation } from "react-i18next";

const VisionAndMission = () => {
  const { t } = useTranslation();

  return (
    <article>
      <div className="w-11/12 py-20 mx-auto">
        <h1 className="text-mainBlue text-[32px] font-bold my-4 text-center">
          {t("ourVisionAndMission")}
        </h1>
        <section className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <VisionCard
            icon={<NetworkIcon />}
            header={t("vision")}
            text={t("toBecomeMostReliable")}
          />
          <VisionCard
            icon={<TruckIcon />}
            header={t("mission")}
            text={t("toProvideFastSolutions")}
          />
          <VisionCard
            icon={<LineChartIcon />}
            header={t("commitment")}
            text={t("continuouslyExpand")}
          />
        </section>
      </div>
    </article>
  );
};

export default VisionAndMission;
